import { combineReducers } from "redux";
import { createItemReducer } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function accessMatrixReducer() {
    return combineReducers({
        ComMonTune_ListWSForPO: createItemReducer("AccessMatrix", "ComMonTune.ListWSForNewPO", false),
        ComMonTune_ListAddWSForPO: createItemReducer("AccessMatrix", "ComMonTune.ListAddWSForNewPO", false)
    });
}